<template>
  <!-- <keep-alive> -->
  <router-view :key="$pageComponentNextKey"/>
  <!-- </keep-alive> -->
</template>

<script>
import pageComponent from '@/mixins/page-component';

export default {
  name: 'RestResourcesParentPage',
  mixins: [pageComponent],
  props: {
    config: { type: Object, required: true },
  },
  provide() {
    return { config: this.config };
  },
  created() {
    const { namespace } = this.config.store;
    this.$store.registerModule(namespace.split('/'), { namespaced: true });
  },
  destroyed() {
    const { namespace } = this.config.store;
    this.$store.unregisterModule(namespace.split('/'));
  },
};
</script>
